import React from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import { entryVerifyStatus } from 'config/entryVerifyStatus';
import { invoiceTypes } from 'editor/game_invoice/utils/invoiceType';

import VerifyStatusLabel from 'client/components/verify/VerifyStatusLabel';
import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';

export default function ResultInfoInvoice({ result = {}, validStatus }) {
    const themeStyle = usePromoSettingThemeStyle();
    const { gameResult: { receiptType, receiptNumber, invoiceNumber } = {} } = result;
    const [title, value] = (() => {
        switch (Number(receiptType)) {
            case invoiceTypes.EINVOICE:
                return [i18n.t('label.result.title.einvoice'), invoiceNumber];
            case invoiceTypes.EINVOICE_CARRIERS:
                return [i18n.t('label.result.title.einvoice_carrier'), invoiceNumber];
            case invoiceTypes.INVOICE:
                return [i18n.t('label.result.title.invoice'), invoiceNumber];
            case invoiceTypes.RECEIPT:
                return [i18n.t('label.result.title.receipt'), receiptNumber];
            default:
                return [];
        }
    })();

    return (
        <>
            <Typography variant="subtitle1" css={wrapperStyle(themeStyle.titleColor)}>
                {title} - {String(value).toUpperCase()}
            </Typography>
            <div css={statusCtyle}>
                {validStatus !== entryVerifyStatus.PASSED && (
                    <VerifyStatusLabel status={validStatus} />
                )}
            </div>
            <Divider css={dividerStyle} />
        </>
    );
}

const wrapperStyle = color => css`
    margin-top: 16px;
    color: ${color};
`;

const statusCtyle = css`
    max-width: 89px;
    margin-top: 20px;
`;

const dividerStyle = css`
    margin: 16px -6px;
`;
